<template>
  <a @click.prevent="contact"><slot v-if="!isDefaultContent || !supportTeam.oc" /><span v-if="isDefaultContent && supportTeam.oc">contact <span>{{ supportTeam.oc.name }}</span>, your Operations Coordinator (OC)</span></a>
</template>

<script>
import $ from 'jquery'
import { getMySupportTeam } from '@/api'

const defaultContent = 'contact your Operations Coordinator (OC)'

export default {
  data () {
    return {
      supportTeam: {
        oc: null,
        asm: null,
        evp: null
      },
      isDefaultContent: false
    }
  },
  async mounted () {
    this.isDefaultContent = defaultContent === $(this.$el).text()
    let response = await getMySupportTeam()
    this.supportTeam = response.data
  },
  methods: {
    contact () {
      //
    }
  }
}
</script>
